export const networkStatus = {
  RUNNING: 0,
  PAUSED: 1,
  PROCESSING: 2,
  ARCHIVED: 3,
  FAILED: 4,
  TERMINATED: 13,
  PROBING: 5,
};

export const NETWORK_STATUS_ENUM = {
  [networkStatus.RUNNING]: "RUNNING",
  [networkStatus.PAUSED]: "PAUSED",
  [networkStatus.PROCESSING]: "PROCESSING",
  [networkStatus.ARCHIVED]: "ARCHIVED",
  [networkStatus.FAILED]: "FAILED",
  [networkStatus.TERMINATED]: "BUSINESS_TERMINATED",
  [networkStatus.PROBING]: "PROBING",
};
